export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-960-ca814347f1bd7ea7a64788ab9be43fd7.webp";